import { Dispatcher } from "../../../../../react-core/Flux/Dispatcher";
import { FluxResponse } from "../../../../Admin/Adviser/Stores/Variable";
import { ResearchISTStoreStatic } from "./ResearchIstStoreStatic";

export const ResearchISTDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const ResearchISTStore: ResearchISTStoreStatic = new ResearchISTStoreStatic();
